export function Card({ title, headerRight, children, style = {}, className = "" }) {
  return (
    <div className={"clarity-card" + (className ? " " + className : "")} style={{ background: "var(--c-bg-card)", borderRadius: 20, padding: "14px 16px", border: "1.5px solid var(--c-border)", boxShadow: "0 4px 24px var(--c-shadow)", ...style }}>
      {title && (
        headerRight ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 10 }}>
            <p className="clarity-card-title" style={{ margin: 0, fontSize: 11, fontWeight: 700, color: "var(--c-text-soft)", letterSpacing: "0.6px" }}>{title.toUpperCase()}</p>
            {headerRight}
          </div>
        ) : (
          <p className="clarity-card-title" style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, color: "var(--c-text-soft)", letterSpacing: "0.6px" }}>{title.toUpperCase()}</p>
        )
      )}
      {children}
    </div>
  );
}
